import type { Snapshot } from '@ember-data/legacy-compat/-private';
import type { ModelSchema } from '@ember-data/store/types';
import { decamelize } from 'frontend-utils/utils/convert-case';
import ApplicationSerializer from 'lumen/serializers/application';

export default class ParityStrategyIssueSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'issue') {
      // Override payloadKey 'issue' to 'parity-strategy/issue' (PATCH response)
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-strategy/issue');
    }

    if (key === 'issues') {
      // Override payloadKey 'issues' to 'parity-strategy/issues' (GET response)
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-strategy/issues');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(
    typeClass: ModelSchema,
    hash: { channel: string; hotelinfo_id: number; ota_hotel_info?: string },
  ) {
    // PI-1496 hotelinfo_id is undefined in response of PATCH request
    if (hash.channel !== undefined && hash.hotelinfo_id !== undefined) {
      hash.ota_hotel_info = [hash.channel, hash.hotelinfo_id].join(',');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.normalize(typeClass, hash);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  payloadKeyFromModelName() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.payloadKeyFromModelName('issue');
  }

  serialize(
    snapshot: Snapshot,
    options: { excludeUnchangedAttributes: boolean },
  ): Record<string, unknown> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const payload: Record<string, unknown> = super.serialize(snapshot, options);

    // Exclude unchanged attributes from the payload (for PATCH request)
    if (options.excludeUnchangedAttributes) {
      const reducedPayload: Record<string, unknown> = {};
      const changedAttributes = snapshot.changedAttributes();
      Object.keys(changedAttributes).forEach((key) => {
        reducedPayload[decamelize(key)] = payload[decamelize(key)];
      });
      return reducedPayload;
    }

    return payload;
  }
}
